const SettingsActionTypes = {
    GET_COUNTRIES: 'GET_COUNTRIES',
    SET_COUNTRIES: 'SET_COUNTRIES',
    GET_STATES: 'GET_STATES',
    SET_STATES: 'SET_STATES',
};

export default SettingsActionTypes;